import {Modal} from "react-bootstrap";
import {CheckCircleOutline, HighlightOff} from "@material-ui/icons";
import React from "react";

export function PermitsModal({modalStatus,manageModal, permitsStatus,actualApplication}){


    const getValidationMessage = () => {
        if(permitsStatus){
            return (
                <>
                    <div className="col-6 row justify-content-center">
                        <CheckCircleOutline color="primary" fontSize="large" style={{width: "70px", height:"70px"}}/>
                    </div>
                    <div className="row justify-content-center px-5">
                        <h2 className="text-center">Permits and licenses have been validated and are up to date!</h2>
                        <p className="font-size-lg text-center">{actualApplication.companyName} has compiled with all permits and licenses needed to operate the business. The permit number PU-#### expires 11/22/2021</p>
                    </div>
                </>
            )
        }else{
            return (
                <>
                    <div className="col-6 row justify-content-center">
                        <HighlightOff color="error" fontSize="large" style={{width: "70px", height:"70px"}}/>
                    </div>
                    <div className="row justify-content-center px-5">
                        <h2 className="text-center">{actualApplication.companyName}'s Registro de Comerciante could not be validated.</h2>
                        <p className="font-size-lg text-center">Please contact a {actualApplication.companyName} representative so he can provide the corresponding documentation.</p>
                    </div>
                </>
            )
        }
    }

    const handleClose = () => {
        manageModal({
            permitsModal: false,
            licensesModal: false,
            creditModal: false,
            otherModal: false
        });
    };

    return (
        <>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                show={modalStatus.permitsModal}
                backdrop="static"
                centered={true}
                size="lg"
            >
                <Modal.Body className="overlay overlay-block cursor-default row justify-content-center">
                    {getValidationMessage()}
                    <div className="col-12 row justify-content-center">
                        <button className="btn btn-primary" onClick={handleClose}>
                            Ok
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}